import Placeholders from 'components/BaseHelpers/Placeholders';
import TwoColumnLayout from 'components/BaseHelpers/TwoColumnLayout';

import { ComponentProps } from '../../../types/component-props';
import { CoreTwoColumnLayoutData } from '../../../types/components';

export type CoreTwoColumnLayoutProps = ComponentProps & CoreTwoColumnLayoutData;

const CoreTwoColumnLayout = (props: CoreTwoColumnLayoutProps): JSX.Element => {
  const { placeholders, fields = {} } = props;
  const { containerClassOverride } = fields;

  return (
    <TwoColumnLayout
      leftChildren={<Placeholders placeholders={placeholders.leftColumn} />}
      rightChildren={<Placeholders placeholders={placeholders.rightColumn} />}
      containerClassOverride={containerClassOverride}
    />
  );
};

export default CoreTwoColumnLayout;
